import { MprcJoinComponents } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { useCardContext } from "../../CardBuilder";

///
export const ContentPageModerationClassification: React.FC = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");

    if (pub.approvalStatus == PublicationApprovalStatus.Approved)
        return <></>;

    const components: React.ReactNode[] = [];

    components.push(
        <MprcFeedTypography variant="classification" color={pub.approvalStatus == PublicationApprovalStatus.Rejected ? "error" : undefined}>
            {pub.isDraft
                ? t("Feed.Card.Common.DraftText")
                : pub.approvalStatus == PublicationApprovalStatus.PendingCognitiveAnalysis || pub.approvalStatus == PublicationApprovalStatus.PendingModeratorAction
                    ? t("Feed.Card.Common.PendingApprovalText")
                    : t("Feed.Card.Common.PublicationRejectedText")
            }
        </MprcFeedTypography>
    );

    return (
        <MprcFeedTypography variant="classification" noWrap component="div">
            <MprcJoinComponents separator="&bull;" components={components} />
        </MprcFeedTypography>
    );
};
